// import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
// import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
// import AssignmentTurnedInOutlinedIcon from "@mui/icons-material/AssignmentTurnedInOutlined";
// import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
// import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
// import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
// import LocalAtmOutlinedIcon from "@mui/icons-material/LocalAtmOutlined";
// import MedicalInformationOutlinedIcon from "@mui/icons-material/MedicalInformationOutlined";
// import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
// import SummarizeOutlinedIcon from "@mui/icons-material/SummarizeOutlined";
// import VideoSettingsOutlinedIcon from "@mui/icons-material/VideoSettingsOutlined";
// import ViewSidebarOutlinedIcon from "@mui/icons-material/ViewSidebarOutlined";
import { SvgIconProps } from "@mui/material";
// import { OverridableComponent } from "@mui/material/OverridableComponent";
// import { createSvgIcon } from "@mui/material/utils";
// import WorkHistoryOutlinedIcon from "@mui/icons-material/WorkHistoryOutlined";
// import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
// LockOutlinedIcon removed — portal-access moved under Profile
import { PatientTabIcons } from "../../../../../../components/svg-icons/navbarIcons";

type Tab =
  | "index"
  | "demographics"
  | "visit-history"
  | "order"
  | "clinical-details"
  | "prescription"
  | "history"
  | "tasks"
  | "documents"
  | "communication"
  | "financial"
  | "forms"
  | "assessment"
  | "referral";

type PatientTab = {
  value: Tab;
  label: string;
  count?: number;
  icon: (props: SvgIconProps) => JSX.Element;
}[];

export const PATIENT_CHART_TABS: PatientTab = [
  // {
  //   value: "",
  //   label: "Dash.",
  //   icon: DashboardOutlinedIcon,
  // },
  {
    value: "index",
    label: "Timeline",
    icon: PatientTabIcons.Timeline,
  },
  {
    value: "demographics",
    label: "Profile",
    icon: PatientTabIcons.Profile,
  },

  {
    value: "visit-history",
    label: "Visit His.",
    icon: PatientTabIcons["Visit History"],
  },
  {
    value: "order",
    label: "Order",
    icon: PatientTabIcons.Order,
  },
  {
    value: "clinical-details",
    label: "Clinicals",
    icon: PatientTabIcons.Clinicals,
  },
  {
    value: "prescription",
    label: "Rx",
    icon: PatientTabIcons.Rx,
  },
  {
    value: "history",
    label: "Hx",
    icon: PatientTabIcons.Hx,
  },
  {
    value: "tasks",
    label: "Tasks",
    icon: PatientTabIcons.Tasks,
  },
  {
    value: "referral",
    label: "Referrals",
    icon: PatientTabIcons.Referrals,
  },
  {
    value: "documents",
    label: "Docs",
    icon: PatientTabIcons.Docs,
  },
  // {
  //   value: "education",
  //   label: "Edu.",
  //   icon: LocalLibraryOutlinedIcon,
  // },
  {
    value: "communication",
    label: "Comm.",
    icon: PatientTabIcons.Communications,
    count: 10,
  },
  {
    value: "financial",
    label: "Financials",
    icon: PatientTabIcons.Financials,
  },
  {
    value: "forms",
    label: "Forms",
    icon: PatientTabIcons.Forms,
  },
  {
    value: "assessment",
    label: "Assessments",
    icon: PatientTabIcons.Assessments,
  },
  // portal-access is now a sub-tab under Profile/Demographics
  // {
  //   value: "script-sure",
  //   label: "Patient Invite",
  //   icon: InsertInvitationIcon,
  // },
];

export const TABS_COUNT_MAPPER: Record<string, number> = {
  communication: 0,
  financial: 0,
  forms: 0,
  assessment: 0,
  referral: 0,
  documents: 0,
  tasks: 0,
  history: 0,
  prescription: 0,
  "clinical-details": 0,
  order: 0,
  "visit-history": 0,
  demographics: 0,
};
